import { render, staticRenderFns } from "./BaseInputMask.vue?vue&type=template&id=1476a671"
import script from "./BaseInputMask.vue?vue&type=script&lang=js"
export * from "./BaseInputMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports